<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div>
    <details-modal
      :show="show"
      :current-operation="currentOperation"
      :loading="loading"
      @close="closeModal"
      @cancel="closeModal"
      @create="createRecord"
      @update="updateRecord"
      @delete="deleteRecord"
    >
      <Form :validation-schema="validationSchema" validate-on-mount>
        <div class="form-group">
          <label class="control-label">*Nom</label>
          <Field
            name="name"
            v-model="room.name"
            v-slot="{ field, errorMessage }"
          >
            <input v-bind="field" class="form-control" type="text" />
            <small v-show="errorMessage" class="text-danger">
              Le nom est requis.
            </small>
          </Field>
        </div>
        <div class="form-group">
          <label class="control-label">*Capacité</label>
          <Field
            name="capacity"
            v-model="room.capacity"
            v-slot="{ field, errorMessage }"
          >
            <input v-bind="field" class="form-control" type="number" />
            <small v-show="errorMessage" class="text-danger">
              La capacité est requise.
            </small>
          </Field>
        </div>
        <div class="form-group">
          <label class="control-label">Description</label>
          <textarea v-model="room.description" class="form-control" rows="3" />
        </div>
        <p><label>* champs obligatoires</label></p>
      </Form>
      <p v-if="errorMessage" class="error-message-in-modal">
        {{ errorMessage }}
      </p>
    </details-modal>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import { Form, Field } from 'vee-validate';
import * as yup from 'yup';
import DetailsModal from './DetailsModal.vue';

export default {
  components: {
    DetailsModal,
    Form,
    Field,
  },
  props: ['show', 'currentOperation', 'room'],
  data() {
    return {
      errorMessage: '',
      validationSchema: {
        name: yup.string().required(),
        capacity: yup.string().required(),
      },
      loading: false,
    };
  },
  methods: {
    async createRecord() {
      // Validate each field with vee-validate, and post the new room.
      const validationSchemaObject = yup.object(this.validationSchema);
      const isRoomValid = await validationSchemaObject.isValid(this.room);

      if (isRoomValid) {
        this.errorMessage = null;

        this.loading = true;

        this.$http
          .post(`${process.env.VUE_APP_INTRANET_API_URL}/rooms`, {
            ...this.room,
          })
          .then(() => {
            this.closeModal();
          })
          .catch((error) => {
            this.errorMessage = "Une erreur est survenue lors de l'ajout de la salle, veuillez réessayer ou contacter le webmaster.";
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.errorMessage = 'Un ou plusieurs champs sont invalides.';
      }
    },
    async updateRecord() {
      // Validate each field with vee-validate, and post the new room.
      const validationSchemaObject = yup.object(this.validationSchema);
      const isRoomValid = await validationSchemaObject.isValid(this.room);

      if (isRoomValid) {
        this.errorMessage = null;

        this.loading = true;

        this.$http
          .patch(
            `${process.env.VUE_APP_INTRANET_API_URL}/rooms/${this.room.id}`,
            {
              ...this.room,
            },
          )
          .then(() => {
            this.closeModal();
          })
          .catch((error) => {
            this.errorMessage = 'Une erreur est survenue lors de la modification de la salle, veuillez réessayer ou contacter le webmaster.';
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.errorMessage = 'Un ou plusieurs champs sont invalides.';
      }
    },
    deleteRecord() {
      this.errorMessage = null;

      Swal.fire({
        title: 'Êtes-vous sûr de vouloir supprimer cette salle ?',
        text: "Il ne sera pas possible d'annuler cette suppression !",
        icon: 'warning',
        showCancelButton: true,
        customClass: {
          confirmButton: 'btn btn-success btn-fill',
          cancelButton: 'btn btn-danger btn-fill',
        },
        confirmButtonText: 'Oui, effacer',
        cancelButtonText: 'Non, conserver',
        buttonsStyling: false,
      })
        .then((result) => {
          if (result.isConfirmed) {
            this.$http
              .delete(
                `${process.env.VUE_APP_INTRANET_API_URL}/rooms/${this.room.id}`,
              )
              .then(() => {
                this.closeModal();
              })
              .catch((error) => {
                this.errorMessage = 'Une erreur est survenue lors de la suppression de la salle, veuillez réessayer ou contacter le webmaster.';
              });
          }
        })
        .catch(() => {});
    },
    closeModal() {
      this.$emit('close');
      this.errorMessage = '';
    },
  },
};
</script>
